// ABOUTME: API service exports for backend communication.
// ABOUTME: Provides typed API client for all backend endpoints.

import { api, setTokenGetter, ApiError, userApi, investigationApi } from './client';

// Export the API client
export const apiClient = api;

// Re-export utilities and APIs
export { setTokenGetter, ApiError, userApi, investigationApi };

// Re-export types
export type { PaginationParams } from '@/types/api';
